import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// SVG Imports
import NavXpentraLogo from "../../../assets/landingPage/NavXpentraLogo.svg";
import NavXpentraLogoMob from "../../../assets/landingPage/NavXpentraLogoMob.svg";

// REDUX Imports
import {
  mobilelandingpagestate,
  weblandingpagestate,
} from "../../../redux/features/landingpagestate/landingpagestate";
import ICONS from "../../../assets/Icons";
import SVGComponent from "../../_utils/SVGComponent";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isAboutUsOpen, setIsAboutUsOpen] = useState(false);
  const toggleAboutUsDropdown = () => setIsAboutUsOpen((prev) => !prev);
  const isActive = (route) => location.pathname === route;

  const [isDarkSectionActive, setIsDarkSectionActive] = useState(false);
  const [isAboutPopOpen, setIsAboutPopOpen] = useState(false);
  const [isPopOpen, setIsPopOpen] = useState(false);
  const navItems = [
        { title: "Home", href: "/" },
        { title: "Product", href: "/product" },
    {
      title: "About Us",
      href: "/aboutus",
      dropdown: true,
      activeRoutes: ["/aboutus", "/advisors"],
    },
        { title: "Pricing", href: "/pricing" },
        { title: "Contact Us", href: "/contactus" },
  ];
    
  useEffect(() => {
    dispatch(weblandingpagestate(isPopOpen || isAboutPopOpen ? true : false));
  }, [isPopOpen, isAboutPopOpen, dispatch]);

  useEffect(() => {
    dispatch(mobilelandingpagestate(isDarkSectionActive));
  }, [dispatch, isDarkSectionActive]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const closePopoverIfActive = (route) => {
    if (isActive(route)) {
      setIsPopOpen(false);
      setIsAboutPopOpen(false);
    } else {
      navigate(route);
    }
  };

  const closePopoverAboutIfActive = (route) => {
    if (isActive(route)) {
      setIsAboutPopOpen(false);
      setIsPopOpen(false);
    } else {
      navigate(route);
    }
  };
  useEffect(() => {
    if (isPopOpen) {
      setIsPopOpen(false);
    }
    if (isAboutPopOpen) {
      setIsAboutPopOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const toggleHeight = () => {
    setIsOpen(!isOpen);
    setIsDarkSectionActive(!isOpen);
  };

  const handleNavigate = (href) => {
  navigate(href);
    toggleHeight();
  };

return (
  <>
    <div
      className="bg-[#244277] fixed top-0 left-0
        w-screen h-[60px] lg:z-z-index-header z-50"
      style={{
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.25)",
      }}
    >
      <div className="flex items-center justify-between bg-[#3A5686] lg:bg-inherit
        h-full lg:h-auto w-full max-w-[1024px] mx-auto px-[20px] lg:px-0 lg:py-[15px]"
      >
        <div
          onClick={() => navigate("/")}
          className="lg:cursor-pointer"
        >
          <picture>
            <source
              media="(min-width: 1024px)"
              srcSet={NavXpentraLogo}
            />
            <img
              src={NavXpentraLogoMob}
              alt="NavXpentraLogo"
            />
          </picture>
        </div>
        <div className="hidden lg:flex gap-4 text-[#f9f9f9] text-xs">
        {navItems.map((item) => {
            const itemIsActive = item.activeRoutes
            ? item.activeRoutes.some((route) => isActive(route))
            : isActive(item.href);

            if (item.dropdown) {
            return (
                <div
                key={item.href}
                className={`justify-center content-center rounded-[17px] px-[25px] py-[5px] 
                    cursor-pointer flex items-center gap-[5px] ${
                    itemIsActive
                    ? "bg-[#3A5686]"
                    : "hover:bg-[#516B93]"
                }`}
                onClick={() => {
                    setIsAboutPopOpen(!isAboutPopOpen);
                    if (isPopOpen) {
                    setIsPopOpen(false);
                    }
                }}
                >
                About Us
                <span>
                    <div
                    className={`h-[16px] transition-transform duration-300 ${
                        isAboutPopOpen
                        ? "-rotate-90"
                        : "rotate-90"
                    }`}
                    >
                    <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE}
                        color="var(--text-primary)"
                        width="var(--icon-xs)"
                        height="var(--icon-xs)"
                    />
                    </div>
                </span>
                </div>
            );
            }

            return (
            <div
                key={item.href}
                className={`justify-center content-center rounded-[17px] px-[25px] py-[5px] cursor-pointer ${
                itemIsActive
                    ? "bg-[#3A5686]"
                    : "hover:bg-text-primary hover:bg-opacity-20"
                }`}
                onClick={() => navigate(item.href)}
            >
                {item.title}
            </div>
            );
        })}
        </div>
        <div className="flex gap-2.5">
            <div className="rounded-[5px] lg:rounded-[17px] w-[91px] lg:w-auto h-[32px] lg:h-auto py-2 lg:py-[5px] 
                px-[30px] lg:px-[25px] text-xs bg-text-primary text-[#1D3A6D] hover:bg-opacity-20 
                hover:text-[#f9f9f9] hover:font-semibold lg:justify-center lg:ds lg:content-center
                lg:cursor-pointer 
            "
            onClick={() => navigate("/login")}
            >
            Login
            </div>
            <div className="lg:hidden my-auto">
            <img
                width={16}
                height={16}
                src={ICONS?.HAMBURGER_MOBILE}
                alt="HamBurgerMobile"
                onClick={() => toggleHeight()}
            />
            </div>
        </div>
      </div>
      <div
          className={`${
          isPopOpen ? "h-[278px]" : "h-0"
          } transition-all duration-300 relative`}
      >
        <div
        className={`absolute top-[-18px] left-0 h-screen w-screen bg-custom-backdrop transition-opacity duration-300 ${
            isPopOpen
            ? "opacity-80 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={() => {
            setIsPopOpen(false);
            setIsAboutPopOpen(false);
        }}
        />

        <div
        className={`max-w-[1024px] mx-auto mt-[20px] pt-[5px] flex relative transition-all duration-300 overflow-hidden ${
            isPopOpen ? "h-[278px]" : "h-0"
        }`}
        >
        <div className="bg-Blue-3 w-1/2 rounded-l-[10px] p-[20px] text-[#f9f9f9] flex flex-col gap-[5px]">
            <div className="text-font-md font-semibold">
            Unified Financial Insights
            </div>

            <div className="text-font-sm">
            Xpentra is a technology-driven platform designed to provide
            CFOs, COOs, and other CXOs with a unified interface that
            aggregates essential financial data and insights. By
            consolidating information across banking functions, Xpentra
            enables faster, more informed decision-making. With real-time
            data, customizable reporting, and seamless bank integrations,
            Xpentra offers a comprehensive view that simplifies complex
            workflows and enhances operational control-empowering leadership
            to drive strategy with greater accuracy and agility.
            </div>
        </div>

        <div className="bg-Blue-4 w-1/2 rounded-r-[10px] p-[20px] text-[#f9f9f9] flex flex-col gap-[20px]">
            <div className="text-base font-semibold">
            Product Features
            </div>

            <div className="flex gap-[20px] h-[63px]">

            {/* Bank Statements */}
            <div
                className="bg-opacity-20 hover:bg-text-primary hover:bg-opacity-20 rounded-[10px] w-1/2 p-[10px] pl-[15px] flex justify-between cursor-pointer"
                onClick={() =>
                closePopoverIfActive("/bank_statement")
                }
            >
                <div>
                <div className="text-xs text-[#f9f9f9]">
                    Bank Statements
                </div>

                <div className="text-font-xxs text-text-secondary">
                    Bank statements: Comprehensive financial insights in
                    one place
                </div>
                </div>

                <div className="flex">
                <div className="h-[15px] w-[15px] rounded-[246px] bg-Blue-4 flex items-center justify-center">
                    <div className="ml-[2px]">
                    <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE}
                        color="var(--text-primary)"
                        width="var(--icon-xs)"
                        height="var(--icon-xs)"
                    />
                    </div>
                </div>
                </div>
            </div>

            {/* View All Balances */}
            <div
                className="bg-opacity-20 hover:bg-text-primary hover:bg-opacity-20 rounded-[10px] w-1/2 p-[10px] pl-[15px] flex justify-between cursor-pointer"
                onClick={() =>
                closePopoverIfActive("/view_all_balances")
                }
            >
                <div>
                <div className="text-xs text-[#f9f9f9]">
                    View All Balances
                </div>

                <div className="text-font-xxs text-text-secondary">
                    View all balances: Simplifying financial oversight
                </div>
                </div>

                <div className="flex">
                <div className="h-[15px] w-[15px] rounded-[246px] bg-Blue-4 flex items-center justify-center">
                    <div className="ml-[2px]">
                    <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE}
                        color="var(--text-primary)"
                        width="var(--icon-xs)"
                        height="var(--icon-xs)"
                    />
                    </div>
                </div>
                </div>
            </div>

            </div>
        </div>
        </div>

        {/* =================================================
            DESKTOP ABOUT US POPUP
        ================================================== */}
        <div
        className={`${
            isAboutPopOpen ? "h-[165px]" : "h-0"
        } transition-all duration-300 relative`}
        >
        {/* About backdrop */}
        <div
            className={`absolute top-[-23px] mx-auto h-screen w-screen bg-custom-backdrop transition-opacity duration-300 ${
            isAboutPopOpen
                ? "opacity-80 pointer-events-auto"
                : "opacity-0 pointer-events-none"
            }`}
            onClick={() => {
            setIsAboutPopOpen(false);
            setIsPopOpen(false);
            }}
        />

        {/* About popup */}
        <div
            className={`max-w-[1024px] mx-auto flex relative transition-all duration-300 overflow-hidden ${
            isAboutPopOpen ? "h-[165px]" : "h-0"
            }`}
        >
            <div className="bg-[#244277] mx-auto rounded-[10px] p-[20px] text-[#f9f9f9] flex flex-col gap-[20px] w-[532px]">

            <div className="text-font-md font-semibold">
                About Us
            </div>

            <div className="flex gap-[20px] h-[63px]">

                {/* About Xpentra */}
                <div
                className="bg-[#4A689D] hover:bg-text-primary hover:bg-opacity-20 rounded-[10px] w-full p-[10px] pl-[15px] flex justify-between cursor-pointer"
                onClick={() =>
                    closePopoverAboutIfActive("/aboutus")
                }
                >
                <div className="cursor-pointer">
                    <div className="text-xs text-[#f9f9f9]">
                    About Xpentra
                    </div>

                    <div className="text-font-xxs text-text-secondary">
                    Get to know Xpentra, our story, and the vision
                    behind our innovative solutions.
                    </div>
                </div>

                <div className="flex">
                    <div className="h-[15px] w-[15px] rounded-[246px] bg-Blue-4 flex items-center justify-center">
                    <div className="ml-[2px]">
                        <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE}
                        color="var(--text-primary)"
                        width="var(--icon-xs)"
                        height="var(--icon-xs)"
                        />
                    </div>
                    </div>
                </div>
                </div>

                {/* Management */}
                <div
                className="bg-[#4A689D] hover:bg-text-primary hover:bg-opacity-20 rounded-[10px] w-full p-[10px] pl-[15px] flex justify-between cursor-pointer"
                onClick={() =>
                    closePopoverAboutIfActive("/advisors")
                }
                >
                <div>
                    <div className="text-xs text-[#f9f9f9]">
                    Management
                    </div>

                    <div className="text-font-xxs text-text-secondary">
                    Meet the team driving Xpentra’s success and shaping
                    its future.
                    </div>
                </div>

                <div className="flex">
                    <div className="h-[15px] w-[15px] rounded-[246px] flex items-center justify-center">
                    <div className="ml-[2px]">
                        <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE}
                        color="var(--text-primary)"
                        width="var(--icon-xs)"
                        height="var(--icon-xs)"
                        />
                    </div>
                    </div>
                </div>
                </div>

            </div>
            </div>
        </div>
        </div>
      </div>
    </div>


    <div className="lg:hidden">
      {/* Backdrop */}
      <div
        className={`bg-custom-backdrop opacity-80 z-40 fixed top-0 left-0 w-screen h-screen ${
          isOpen ? "block" : "hidden"
        }`}
        onClick={toggleHeight}
      />
      {/* Bottom menu */}
      <div
        className={`fixed bottom-0 w-screen z-50 transition-all duration-300 ${
          isOpen ? "h-auto" : "h-0"
        }`}
      >
        {/* Close button */}
        <div
          className="h-[80px]"
          onClick={toggleHeight}
        >
          <img
            className="mx-auto"
            src={ICONS?.CLOSE_WITH_GREY_CIRCLE}
            alt="CloseWithGreyCircle"
          />
        </div>
        <div className="bg-[#244277] rounded-t-[20px] py-[30px]">
          {navItems.map((item) => {
            const itemIsActive = item.activeRoutes
              ? item.activeRoutes.some((route) => isActive(route))
              : isActive(item.href);

            if (item.dropdown) {
              return (
                <div key={item.href}>

                  <div
                    className={`py-[16px] px-[30px] text-xs font-semibold text-[#f9f9f9] flex justify-between cursor-pointer ${
                      itemIsActive
                        ? "text-pending"
                        : "text-[#f9f9f9]"
                    }`}
                    onClick={toggleAboutUsDropdown}
                  >
                    About Us

                    <span>
                      <div
                        className={`h-[16px] transition-transform duration-300 ${
                          isAboutUsOpen
                            ? "-rotate-90"
                            : "rotate-90"
                        }`}
                      >
                        <SVGComponent
                          url={ICONS?.ARROW_RIGHT_WHITE}
                          color="var(--text-primary)"
                          width="var(--icon-xs)"
                          height="var(--icon-xs)"
                        />
                      </div>
                    </span>
                  </div>

                  {/* Mobile About Dropdown */}
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isAboutUsOpen
                        ? "max-h-[200px] opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="px-[30px]">
                      <div className="px-[20px]">
                        <div className="border-l-[2px] h-[64px] flex flex-col gap-[20px] pl-[10px]">

                          {/* About Xpentra */}
                          <div
                            className={`font-semibold text-[#f9f9f9] text-xs ${
                              isActive("/aboutus")
                                ? "text-pending"
                                : "text-[#f9f9f9]"
                            }`}
                            onClick={() =>
                              handleNavigate("/aboutus")
                            }
                          >
                            About Xpentra
                          </div>

                          {/* Management */}
                          <div
                            className={`font-semibold text-[#f9f9f9] text-xs ${
                              isActive("/advisors")
                                ? "text-pending"
                                : "text-[#f9f9f9]"
                            }`}
                            onClick={() =>
                              handleNavigate("/advisors")
                            }
                          >
                            Management
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }

            return (
              <div
                key={item.href}
                className={`py-[16px] pl-[30px] text-xs font-semibold text-[#f9f9f9] ${
                  itemIsActive
                    ? "text-pending"
                    : "text-[#f9f9f9]"
                }`}
                onClick={() =>
                  handleNavigate(item.href)
                }
              >
                {item.title}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </>
);
};

export default Navbar;
